export interface MangaCategory {
  id: string;
  name: string;
  tagline: string;
  desc: string;
  icon: string;
  cover: string;
  color: string;
  count: number;
}

export const categories: MangaCategory[] = [
  {
    id: "love",
    name: "恋爱",
    tagline: "怦然心动的青春恋曲",
    desc: "校园纯爱、都市甜宠、狗粮日常，酸甜交织的恋爱故事一网打尽。",
    icon: "ri-heart-3-line",
    cover: "https://readdy.ai/api/search-image?query=romantic%20anime%20illustration%20of%20two%20young%20students%20under%20cherry%20blossom%20tree%2C%20warm%20pink%20and%20coral%20palette%2C%20soft%20gradient%20sky%2C%20youthful%20energetic%20manga%20cover%20art%20with%20clean%20vector%20style%20and%20gentle%20lighting&width=600&height=400&seq=cat-love&orientation=landscape",
    color: "primary",
    count: 1286,
  },
  {
    id: "shounen",
    name: "热血",
    tagline: "燃到沸腾的少年之魂",
    desc: "战斗冒险、逆袭成长、兄弟情谊，每一话都让人血脉偾张的燃系佳作。",
    icon: "ri-fire-line",
    cover: "https://readdy.ai/api/search-image?query=epic%20battle%20anime%20illustration%20of%20young%20warrior%20with%20flame%20aura%2C%20dynamic%20motion%20blur%2C%20warm%20orange%20and%20red%20gradient%20background%2C%20intense%20energetic%20shonen%20manga%20cover%20art%20with%20dramatic%20lighting&width=600&height=400&seq=cat-shounen&orientation=landscape",
    color: "accent",
    count: 1523,
  },
  {
    id: "suspense",
    name: "悬疑",
    tagline: "细思极恐的烧脑谜局",
    desc: "推理探案、心理博弈、层层反转，在谜雾中寻找真相的高能之作。",
    icon: "ri-search-eye-line",
    cover: "https://readdy.ai/api/search-image?query=dark%20mystery%20anime%20illustration%20of%20detective%20silhouette%20with%20magnifying%20glass%20and%20foggy%20cityscape%2C%20teal%20and%20deep%20green%20tone%2C%20moody%20cinematic%20lighting%2C%20suspenseful%20manga%20cover%20art&width=600&height=400&seq=cat-suspense&orientation=landscape",
    color: "primary",
    count: 986,
  },
  {
    id: "healing",
    name: "治愈",
    tagline: "温柔治愈心灵的港湾",
    desc: "暖心日常、猫咪萌宠、慢生活物语，抚平疲惫治愈焦虑的柔软故事。",
    icon: "ri-sun-line",
    cover: "https://readdy.ai/api/search-image?query=cozy%20healing%20anime%20illustration%20of%20cat%20resting%20by%20window%20with%20soft%20sunlight%20and%20plants%2C%20cream%20and%20mint%20warm%20palette%2C%20gentle%20soothing%20manga%20cover%20art%20with%20soft%20edges&width=600&height=400&seq=cat-healing&orientation=landscape",
    color: "secondary",
    count: 1124,
  },
  {
    id: "fantasy",
    name: "奇幻",
    tagline: "天马行空的异世奇旅",
    desc: "魔法异界、龙与神族、想象力爆炸，构筑专属你的奇幻冒险世界。",
    icon: "ri-sparkling-2-line",
    cover: "https://readdy.ai/api/search-image?query=magical%20fantasy%20anime%20illustration%20of%20floating%20island%20with%20castle%20and%20flying%20dragon%2C%20vibrant%20peach%20and%20teal%20gradient%20sky%2C%20dreamy%20sparkling%20manga%20cover%20art%20with%20rich%20detail&width=600&height=400&seq=cat-fantasy&orientation=landscape",
    color: "accent",
    count: 1389,
  },
  {
    id: "campus",
    name: "校园",
    tagline: "那些年我们一起追的青春",
    desc: "教室、社团、课桌前的故事，青春校园生活里的笑与泪尽在其中。",
    icon: "ri-graduation-cap-line",
    cover: "https://readdy.ai/api/search-image?query=school%20campus%20anime%20illustration%20of%20students%20walking%20on%20sunny%20path%20with%20classroom%20building%20and%20blue%20sky%2C%20fresh%20mint%20and%20peach%20palette%2C%20youthful%20manga%20cover%20art&width=600&height=400&seq=cat-campus&orientation=landscape",
    color: "secondary",
    count: 1108,
  },
  {
    id: "adventure",
    name: "冒险",
    tagline: "踏上未知的征途",
    desc: "探索秘境、环游世界、绝境求生，一段段扣人心弦的壮阔旅程。",
    icon: "ri-compass-3-line",
    cover: "https://readdy.ai/api/search-image?query=adventurer%20anime%20illustration%20of%20backpacker%20overlooking%20mountain%20valley%20with%20river%2C%20warm%20golden%20hour%20light%2C%20teal%20and%20orange%20palette%2C%20epic%20manga%20cover%20art&width=600&height=400&seq=cat-adventure&orientation=landscape",
    color: "primary",
    count: 1045,
  },
  {
    id: "sports",
    name: "运动",
    tagline: "汗水与热泪的竞技场",
    desc: "篮球、足球、田径、电竞，关于热血拼搏与团队荣耀的体育故事。",
    icon: "ri-basketball-line",
    cover: "https://readdy.ai/api/search-image?query=dynamic%20sports%20anime%20illustration%20of%20basketball%20player%20dunking%20with%20stadium%20lights%2C%20energetic%20coral%20and%20teal%20palette%2C%20high%20contrast%20manga%20cover%20art%20with%20motion&width=600&height=400&seq=cat-sports&orientation=landscape",
    color: "accent",
    count: 672,
  },
  {
    id: "comedy",
    name: "搞笑",
    tagline: "笑到停不下来的快乐源泉",
    desc: "无厘头日常、爆笑段子、沙雕主角，专治各种不开心。",
    icon: "ri-emotion-happy-line",
    cover: "https://readdy.ai/api/search-image?query=funny%20comedy%20anime%20illustration%20of%20cartoon%20characters%20laughing%20with%20colorful%20confetti%2C%20bright%20peach%20and%20cream%20palette%2C%20playful%20whimsical%20manga%20cover%20art&width=600&height=400&seq=cat-comedy&orientation=landscape",
    color: "secondary",
    count: 780,
  },
  {
    id: "ancient",
    name: "古风",
    tagline: "刀光剑影的江湖传说",
    desc: "武侠江湖、仙侠修仙、宫廷权谋，东方韵味十足的传奇篇章。",
    icon: "ri-sword-line",
    cover: "https://readdy.ai/api/search-image?query=ancient%20wuxia%20anime%20illustration%20of%20swordsman%20with%20ink%20wash%20mountain%20background%20and%20maple%20leaves%2C%20warm%20vermilion%20and%20ink%20grey%20palette%2C%20elegant%20chinese%20manga%20cover%20art&width=600&height=400&seq=cat-ancient&orientation=landscape",
    color: "primary",
    count: 935,
  },
];